import { string, shape, number, bool, arrayOf, oneOfType } from 'prop-types';

const foodBasicPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
};

const foodPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  description: string,
};

const supplierFoodTypePropTypes = {
  id: number.isRequired,
  supplierId: number.isRequired,
  foodId: number.isRequired,
  food: shape(foodBasicPropTypes).isRequired,
  cost: number.isRequired,
};

const businessPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  businessTaxId: string.isRequired,
  phone: string,
  email: string,
};

const locationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  address: string.isRequired,
  cityId: number,
};

const supplierPropTypes = {
  id: number.isRequired,
  businessId: number.isRequired,
  business: shape(businessPropTypes).isRequired,
  locationId: number.isRequired,
  location: shape(locationPropTypes).isRequired,
  billingType: string.isRequired,
  type: string,
  creditTime: string.isRequired,
  bankAccountNumber: string,
  active: bool.isRequired,
  supplierFoodTypeList: arrayOf(shape(supplierFoodTypePropTypes)),
};

const cabinCrewBasicPropTypes = {
  cabinCrewId: number,
  cabinCrewName: string.isRequired,
  cabinCrewIdDocumentNumber: string.isRequired,
};

const registeredBusPropTypes = {
  id: number,
  companyBusId: string.isRequired,
};

const itinerarySupplierFoodDetailPropTypes = {
  id: number.isRequired,
  itinerarySupplierFoodId: number.isRequired,
  foodId: number.isRequired,
  food: shape(foodPropTypes).isRequired,
  quantity: number.isRequired,
  cost: number.isRequired,
};

const driverTypePropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  description: string,
};

const driverPropTypes = {
  driverId: number.isRequired,
  driverName: string.isRequired,
  driverIdDocumentNumber: string.isRequired,
  driverType: shape(driverTypePropTypes).isRequired,
};

const passengerFlowDtoPropTypes = {
  ticketTripRequestId: number,
  ticketCode: string,
  seatNumber: number,
  customerId: number,
  customerFullName: string,
  customerDocumentNumber: string,
  isTicket: bool,
  isBoarded: bool,
  isMine: bool,
  hasBoardingDraft: bool,
  kidsOnItineraryId: number,
  movementReasonId: number,
  hasCompletedTrip: bool,
  age: number,
  ticket: bool,
  boarded: bool,
  mine: bool,
  correlative: string,
};

const passengerFlowForLocationPropTypes = {
  locationId: number.isRequired,
  locationName: string.isRequired,
  boardingPassengers: number.isRequired,
  leavingPassengers: number.isRequired,
  boardingFlow: arrayOf(shape(passengerFlowDtoPropTypes)),
  leavingFlow: arrayOf(shape(passengerFlowDtoPropTypes)),
  wasSaved: bool,
  boardingClosed: bool,
  canEdit: bool,
  canAdvanceBoarding: bool,
};

const passengerFlowPropTypes = {
  itineraryId: number.isRequired,
  passengerFlowForLocationList: arrayOf(
    shape(passengerFlowForLocationPropTypes),
  ),
  currentBoardingLocationId: number,
  currentBoardingLocationName: string,
};

const itinerarySupplierFoodPropTypes = {
  id: number.isRequired,
  supplierId: number.isRequired,
  itineraryId: number,
  cabinCrewId: number,
  cabinCrew: shape(cabinCrewBasicPropTypes),
  supplier: shape(supplierPropTypes).isRequired,
  registeredBusId: number.isRequired,
  registeredBus: shape(registeredBusPropTypes).isRequired,
  itinerarySupplierFoodDetailList: arrayOf(
    shape(itinerarySupplierFoodDetailPropTypes),
  ),
  driverList: arrayOf(shape(driverPropTypes)),
  cabinCrewList: arrayOf(shape(cabinCrewBasicPropTypes)),
  passengerFlow: shape(passengerFlowPropTypes),
  createDate: oneOfType([number, string]),
};

export default itinerarySupplierFoodPropTypes;
